module.exports = __webpack_public_path__ + "static/media/btn-pines.6b3b083d.png";